import * as React from "react";
import { useAccount } from "../../Account";
import { Toolbar } from "@mui/material";
import { useNavigate, useParams, Outlet } from "react-router-dom";
import AccountGuardianSelector from "./AccountGuardianSelector";

export const AccountLoansPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const { canViewDependentActivity } = useAccount();

  const handleSelectId = (id?: string): void => {
    if (id) {
      navigate(`/myaccount/loans/child/${id}`);
      return;
    }
    navigate(`/myaccount/loans`);
    return;
  };

  return (
    <>
      {canViewDependentActivity && (
        <Toolbar variant="dense">
          <AccountGuardianSelector selectedId={id} onSelect={handleSelectId} />
        </Toolbar>
      )}
      <Outlet />
    </>
  );
};
